import React, { ReactNode } from 'react';
import { Box, useColorModeValue, useDisclosure, Flex } from '@chakra-ui/react';
import Sidebar from '../sidebar';

const Layout = ({ children }: { children: ReactNode }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  return (
    <Flex h="100vh" bg={useColorModeValue('theme.light.body', 'theme.dark.body')}>
      <Sidebar onToggle={onToggle} isOpen={isOpen} display={{ base: 'none', md: 'flex' }} />
      <Box
        w="full"
        py="30px"
        overflow="auto"
        transition="0.5s ease"
        ml={{ base: '60px', md: isOpen ? '290px' : '65px' }}
      >
        <Box mx="55px" flex={1}>
          {children}
        </Box>
      </Box>
    </Flex>
  );
};

export default Layout;
